import { Validators } from '../../../../utils/validators';
import { FormModel } from '../../../../components/Form';

export const AddBudgetForm = (strings: any, sameMonth: boolean, width = 3): FormModel[] => {
  return [
    {
      label: strings.budget_text_month,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'month',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'month',
      validators: width === 12 ? [] : [{ check: Validators.validateMandatoryField }],
      responsive: width === 12 ? { xs: 12 } : { xs: 12, md: 3 },
      required: width === 3,
    },
    {
      label: strings.budget_text_name,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators:
        width === 12 ? [] : [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: width === 12 ? { xs: 12 } : { xs: 12, md: 3 },
      required: width === 3,
    },
    {
      label: strings.budget_text_target,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      disabled: width === 12 ? false : !sameMonth,
      placeholder: '',
      field: 'target',
      validators:
        width === 12 || !sameMonth
          ? []
          : [{ check: Validators.validateMandatoryField }, { check: Validators.validateFloat }],
      responsive: width === 12 ? { xs: 12 } : { xs: 12, md: 3 },
      required: sameMonth && width === 3,
    },
  ];
};
